import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { LoggerService } from '../services/logger.service';
import { TenantService } from '../services/tenant.service'; 
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  public isHome: boolean = false;
  public showModalWizard: boolean = false;

  public isSuperAdmin: boolean = false;
  public isTenantAdmin: boolean = false; // NUEVO: Control de visibilidad del Dashboard
  public tenants: any[] = [];
  public selectedTenant: string = '';

  constructor(
    private router: Router, 
    private authService: AuthService, 
    private logger: LoggerService,
    private tenantService: TenantService
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.isHome = event.url === '/app/home' || event.urlAfterRedirects === '/app/home';
    });
  }

  ngOnInit(): void {
    this.isHome = this.router.url === '/app/home';

    if (this.authService.isLoggedIn()) {
      this.isSuperAdmin = this.authService.isSuperAdmin();
      
      if (this.isSuperAdmin) {
        this.selectedTenant = this.authService.getActiveTenantId() || '';
        this.loadTenants();
      }

      this.authService.loadMyPermissions().subscribe({
        next: () => {
          this.logger.log('Permisos recuperados correctamente.');
          
          // NUEVO: Evaluamos si es Administrador de Tenant basándonos en sus permisos
          const currentUser = this.authService.getCurrentUser();
          this.isTenantAdmin = !this.isSuperAdmin && !!currentUser?.tenant?.id && 
              (this.authService.hasPermission('menu:users:manage') || this.authService.hasPermission('all:manage'));
        },
        error: (err) => this.logger.error('No se pudieron recuperar los permisos', err)
      });
    }
  }

  private loadTenants(): void {
    this.tenantService.getAllTenants().subscribe(
      (data) => {
        this.tenants = data;
      },
      (error) => this.logger.error('Error al cargar tenants', error)
    );
  }

  onTenantChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const newTenantId = target.value;

    this.authService.setActiveTenantId(newTenantId);
    window.location.href = '/app/home';
  }

  openWizard() { this.showModalWizard = true; }
  closeWizard() { this.showModalWizard = false; }

  logout() {
    this.authService.logout();
  }
}